export default {
  host: process.env.REACT_APP_API_HOST,
  debug: process.env.REACT_APP_API_DEBUG === 'true',
}
